export const getStyles = isFluentNewUI => () => ({
  linkText: {
    fontWeight: 'bold',
  },
  modalHeader: {
    fontSize: isFluentNewUI ? '20px' : '14px',
  },
  formBody: {
    fontSize: isFluentNewUI ? '14px' : '12px',
    marginTop: '10px',
  },
  formPoint: {
    lineHeight: '20px',
  },
  closeButton: {
    display: 'block',
    width: isFluentNewUI ? '14px' : '24px',
    height: isFluentNewUI ? '14px' : '24px',

    '&.close': isFluentNewUI ? {
      opacity: '1',
    } : {},

    '& .closeimage': isFluentNewUI ? {
      fontSize: '14px',
      fontStyle: 'normal',
      fontFamily: 'MsAds MDL2 Assets',
      fontWeight: 'normal',
      color: '#0078d4',
      '&:before': {
        content: '"\\E711"',
      },
    } : {},
  },
  linkContainer: {
    marginBottom: '20px',
  },
  learnMore: {
    textDecoration: 'underline',
    padding: 0,
  },
  bodyLabel: {
    marginBottom: '10px',
    marginTop: '10px',
  },
  button: {
    marginRight: '7px',
  },
});
